import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const DelimeterEmptyState = {
  delimeters: [],
  selectedDelimeter: null,
};

export const DelimeterKey = 'delimeters';

export const delimetersSlice = createSlice({
  name: 'delimeters',
  initialState: getLocalStorage(LocalStorageTypes.DELIMETERS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.DELIMETERS))
    : DelimeterEmptyState,
  reducers: {
    setDelimeters: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.DELIMETERS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedDelimeter: (state, action) => {
      const result = { ...state, selectedDelimeter: action.payload };
      persistLocalStorage(DelimeterKey, result);
      return result;
    },
    resetDelimeters: () => {
      clearLocalStorage('delimeters');
      return DelimeterEmptyState;
    },
  },
});

export const { setDelimeters, updateSelectedDelimeter, resetDelimeters } =
  delimetersSlice.actions;
